import React from 'react';
import { featuresTypes, zIndexs } from './Options';

import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Circle as CircleStyle, Fill, Stroke, Icon, Style } from 'ol/style';
import UIDateFormater, {
  DateType,
} from '../../../containers/UIhelper/UIDateFormater';
const proj = require('ol/proj');

const source = new VectorSource({
  features: [],
});

export const layer = new VectorLayer({
  name: featuresTypes.BURST_ALERT,
  source: source,
  zIndex: zIndexs.alerts,
});

export const setSource = (burstAlerts, props) => {
  let iconFeatures = [];
  burstAlerts.forEach((bAlert) => {
    // Tolerate the coordinate field naming the burst GET returns.
    const lon =
      bAlert.Longitude ?? bAlert.longitude ?? bAlert.lng ?? bAlert.lon;
    const lat = bAlert.Latitude ?? bAlert.latitude ?? bAlert.lat;
    if (lon == null || lat == null) {
      return; // no location yet — skip so the marker isn't placed at [0, 0]
    }
    const iconFeature = new Feature({
      geometry: new Point(proj.transform([lon, lat], 'EPSG:4326', 'EPSG:3857')),
      type: featuresTypes.BURST_ALERT,
      id: bAlert.id,
      status: bAlert.alert_state,
      createDate: bAlert.create_date,
    });
    iconFeature.setStyle(getStyle(iconFeature));
    iconFeatures.push(iconFeature);
  });
  source.addFeatures(iconFeatures);
};

export const getLayers = () => {
  return [layer];
};

export const hasFeatures = () => {
  return source.getFeatures().length > 0;
};

export const clear = () => {
  if (source.getFeatures().length) {
    source.clear();
  }
};

export const getStyle = (_feature, bSelected) => {
  const iconStyle = new Style({
    image: new Icon({
      src: require('../../../../images/ic-burst-red.png'),
      scale: 0.325,
      anchor: [0.5, 0.5],
      opacity: 1,
    }),
  });

  if (bSelected) {
    return [
      new Style({
        image: new Icon({
          src: require('../../../../images/map/sensors/indications/selected-background.png'),
          opacity: 0.75,
          scale: 0.55,
          anchor: [0.5, 0.45],
        }),
      }),
      iconStyle,
    ];
  }

  return [iconStyle];
};

export const getInfoTooltip = (feature) => {
  const attr = feature.getProperties();
  let infoTooltip = {
    type: attr.type,
    id: attr.id,
    status: attr.status,
    createDate: attr.createDate,
  };
  return infoTooltip;
};

export const tooltipRender = (itemInfo, context, props) => {
  const statusOptions = props.options.AlertStateNoise;
  const alertStatus = statusOptions.find(
    (opt) => opt.value === itemInfo.status
  );
  const alertCreateDate = UIDateFormater(
    itemInfo.createDate,
    DateType.DATE,
    props.timeZone,
    props.projectTimezone
  );
  return (
    <span className={'tooltip'}>
      <div className='tooltip-row'>
        {context.t('alert_id_param', { id: itemInfo.id })}
      </div>
      <div className='tooltip-row'>
        {context.t('status_param', { status: alertStatus.DisplayName })}
      </div>
      <div className='tooltip-row'>
        {context.t('created_date') + ' ' + alertCreateDate}
      </div>
    </span>
  );
};
